require('./bootstrap');

import $ from "jquery";
window.$ = $;

require('select2');

// $('#place').select2();

// $('#place').on('change', function (e) {
//     var data = $('#select2').select2("val");
//     @this.set('selected', data)
// });

